import { useContext, useMemo } from "react";

import { allIngredientsSelector } from "../../app/commonSelector";
import { useAppSelector } from "../../app/store/hooks";
import { copyToClipboard, getIngredientUnit, getIngredientValue, mesuringUnits } from "../../components/ingredientsPage/ingredientUtils";
import { ErrorManagementContext } from "../../utils/errorManagement/ErrorManagementProvider";
import { getSortedIngredients } from "../../utils/experience2/ingredientsUtil";
import { logEvents } from "../../utils/logging";

const useCopyIngredients = () => {
  const { cookClubLog } = useContext(ErrorManagementContext);
  const recipe = useAppSelector((state) => state.recipePage.recipe)
  const servingSize = useAppSelector((state) => state.recipePage.servingSize)
  const user = useAppSelector((state) => state.main.user);
  const device = useAppSelector((state) => state.main.device);
  const ingredientsPerServing = useAppSelector(allIngredientsSelector)

  const filteredRecipeIngredients = useMemo(() => {
    const { vegetables, pantry, spices: { powder, whole } } = getSortedIngredients(ingredientsPerServing)
    return [...vegetables, ...pantry, ...powder, ...whole]
  }, [ingredientsPerServing])

  const SnackbarText = () => {
    cookClubLog(
      "",
      "Copied Ingredients!",
      '',
      { ui: { type: "info" }, browserConsole: true })
  }

  const renderIngredients = useMemo(() => filteredRecipeIngredients.sort((x: any, y: any) => y.weighScaleAmount.valueNumberType - x.weighScaleAmount.valueNumberType), [filteredRecipeIngredients])

  const ingredientsData = `${recipe?.metadata?.name}\n` + `Serving Size : ${servingSize}\n` +
    renderIngredients.map((recipe: any, index: number) => {

      const { displayName, weighScaleAmount } = recipe;
      const [value, unit] = weighScaleAmount?.value.split(" ");

      if (mesuringUnits.DEFAULT_UNIT_ARRAY.includes(unit)) {
        const ingMeasurement = unit === mesuringUnits.TBSP ? `${value} ${mesuringUnits.LARGE_SPOON}` : `${getIngredientValue(value * 2)} ${getIngredientUnit(value * 2)}`
        return `${index + 1}. ${displayName} --> ${ingMeasurement}`;
      }

      return `${index + 1}. ${displayName} --> ${weighScaleAmount.value}`;
    }).join("\n");

  const selectIngredients = async () => {
    const type = "text/plain"
    const sessionId: any = sessionStorage.getItem("sessionId");
    try {
      await copyToClipboard(ingredientsData, type)
      logEvents(sessionId, "APP_INGREDIENTS_COPIED", {
        userId: user?.id,
        deviceId: device?.displayName ?? device?._id,
        RecipeId: recipe?.id,
        renderIngredients,
      });
      SnackbarText()
    } catch (err) {
      console.log(err)
    }
  };
  return selectIngredients;
}

export default useCopyIngredients